export default {"src":"/_next/static/media/apple-icon.04d737f2.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};